<template lang="pug">
#ProfilesList.profiles-list-styles.bg-gray-4
  .overlay.bg-gray-4(@click="$emit('close')")

  .window(v-if="listLoading")
    Skeletor(:height="'100%'", :width="'100%'")

  .window(v-else, data-qa="step0-profiles-modal")
    ProfileHeader(
      @closeClick="$emit('close')"
    )

    section.flex.flex-col.gap-2#profiles
      List(
        :selected="selected",
        @selectActiveProfile="selectProfile",
        @editProfile="editProfile",
        @showDeleteAlert="showDeleteAlert",
        @afterDelete="handleAfterDelete",
        ref="list"
      )

      .buttons.list-buttons.pt-2.mt-auto.flex.flex-col.gap-2
        UiButton.profiles__list-select.select-profile-button(
          @click="emitAndClose",
          data-qa="step0-choose-profile-btn"
        ) {{ $t('choose_button') }}

        UiButton.profiles__new-address(
          color="outline",
          @click="createNewAddress",
          :class="{ 'skeleton-pulse': isProcessing }",
          data-qa="step0-modal-new-address-btn"
        ) {{ $t('new_delivery_address') }}

    Loader(v-if="loading", :filling="true")

    .alert-profile(v-if="visibleDeleteAlert", data-qa="step0-delete-alert")
      .alert-profile__content
        p.title-sm.text-center {{ $t('profiles_delete_modal_title') }}
        .buttons.pt-2.pb-2.mt-auto.flex.gap-2
          UiButton(color="secondary" @click="visibleDeleteAlert=false", data-qa="step0-keep-profile-btn") {{ $t('profiles_modal_button_keep') }}
          UiButton(@click="deleteProfile", data-qa="step0-confirm-delete-btn") {{ $t('profiles_modal_button_delete') }}

</template>

<script>
import List from './List.vue'
import Loader from '@/components/Loader.vue'
import ProfileHeader from './ProfileHeader.vue'
import UiButton from '@/components/ui/UiButton.vue'

export default {
  name: 'ProfilesList',
  components: { ProfileHeader, List, Loader, UiButton },

  props: {
    selectedProfile: { type: Number, default: 0 }, // ID активного профиля от родителя
    listLoading: { type: Boolean, default: false },
    isProcessing: { type: Boolean, default: false },
  },

  data() {
    return {
      selected: 0, // локальный выбор в списке
      action: '', // проброс в Header (если нужен)
      loading: false, // спиннер для List
      profile: { deliveryType: '' }, // минимально для Header
      visibleDeleteAlert: false, // подтверждение удаления
      chosenProfile: null, // профиль, который собираемся удалить
      profileWasDeleted: false, // флаг что профиль был удален
    }
  },

  created() {
    // используем v-model-значение как стартовый выбор
    if (this.selectedProfile) this.selected = Number(this.selectedProfile)
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey)
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscapeKey)
  },
  methods: {
    selectProfile(profileID) {
      this.selected = profileID
    },

    emitSelection() {
      this.$emit('selectActiveProfile', this.selected)
    },

    emitAndClose() {
      this.$store.commit('setCheckoutScenario', 'isSelectedProfile')
      this.$store.commit('setProfileMode', 'updateExisting')
      this.emitSelection()
      this.$emit('close')
    },
    createNewAddress() {
      this.$emit('createNewAddress')
      this.$emit('close')
    },

    handleAfterDelete(data) {
      const { wasLastProfile, deletedSelected } = data
      this.profileWasDeleted = true

      console.log('handleAfterDelete', wasLastProfile, deletedSelected)
      if (wasLastProfile) {
        this.$emit('wasLastProfile')
        this.createNewAddress()
        return
      }
      if (deletedSelected) {
        this.$emit('createNewAddress')
        this.selected = 0
      }
    },
    /* --- удаление профиля --- */
    showDeleteAlert(profile) {
      this.chosenProfile = profile
      this.visibleDeleteAlert = true
    },

    deleteProfile() {
      this.$refs.list.removeProfile(this.chosenProfile) // у List есть метод
      this.visibleDeleteAlert = false
    },

    handleEscapeKey(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.$emit('close')
      }
    },

    editProfile(profileID) {
      this.selectProfile(profileID)
      this.emitAndClose()
    },
  },
}
</script>

<style scoped lang="scss">
.popup-main {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &-days {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
  }

  &-details {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    margin-top: 12px;
    color: #e03b00;
    font-size: 16px;
    font-weight: 500;
  }
}
.alert-profile {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 16px;
    border: 1px solid #e5ecf1;
    background: #fff;
    box-shadow:
      0 2px 2px -1px rgba(4, 8, 13, 0.08),
      0 2px 8px -1px rgba(4, 8, 13, 0.08);
    max-width: 350px;
    width: 100%;

    .buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
}
.list-buttons {
  background: #fff;
}

.back-button {
  text-transform: capitalize !important;
}

.profiles-list-styles {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: calc(100vh - 56px); /* примерная высота плашки браузера */
  z-index: 10000;
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;

  @supports (height: 100dvh) {
    height: 100dvh;
  }

  .disabled {
    pointer-events: none;
  }

  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .window {
    position: relative;
    width: 100%;
    height: 96%;
    max-width: 400px;
    background: #fff;
    z-index: 2;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-radius: 8px;

    @media (max-width: 580px) {
      max-width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 475px) {
    .window {
      height: 100%;
    }
  }

  section {
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0 16px 16px 16px;

    &#addresses {
      margin: 0 !important;
    }
  }

  .profiles {
    padding-top: 16px;
  }
}
</style>
